export const columns = ({ t }) => [
  {
    title: t('Code'),
    name: 'externalId'
  },
  {
    title: t('Name'),
    name: 'name'
  },
  {
    title: t('Description'),
    name: 'description'
  },
  {
    title: t('Status'),
    name: 'status'
  }
];

export const formatData = (items, t) =>
  items.map(item => ({
    id: item.id,
    externalId: item.externalId,
    name: item.name,
    description: item.description,
    expired: item.active,
    status: item.active ? t('Active') : t('Inactive'),
    rowVersion: String(item.rowVersion)
  }));

export default {
  columns,
  formatData
};
